import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import GridMoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { EditAttributes } from "@mui/icons-material";

interface CellActionsProps {
  id: string | number;
  row: any;
  onEdit?: (id: string | number, row: any) => void;
  onEditAttributes?: (id: string | number, row: any) => void;
  onRemove?: (id: string | number, row: any) => void;
}

const CellActions: React.FC<CellActionsProps> = ({
  id,
  row,
  onEdit,
  onEditAttributes,
  onRemove,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit?.(id, row);
    handleClose();
  };

  const handleEditAttributes = () => {
    onEditAttributes?.(id, row);
    handleClose();
  };

  const handleRemove = () => {
    onRemove?.(id, row);
    handleClose();
  };

  return (
    <div>
      <IconButton aria-label="more" id="long-button" onClick={handleClick}>
        <GridMoreVertIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        PaperProps={{
          style: {
            boxShadow: "0px 2px 4px rgba(211, 211, 211, 0.4)",
          },
          backgroundColor: "transparent",
        }}
      >
        {onEdit && (
          <MenuItem onClick={handleEdit}>
            <EditIcon fontSize="small" />
            &nbsp;Edit
          </MenuItem>
        )}
        {onEditAttributes && (
          <MenuItem onClick={handleEditAttributes}>
            <EditAttributes />
            &nbsp; Edit Attributes
          </MenuItem>
        )}
        {onRemove && (
          <MenuItem onClick={handleRemove}>
            <Delete fontSize="small" />
            &nbsp;Remove
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default CellActions;
